import * as React from 'react';
import AccountDetailHeader from '../Admin/Accounts/AccountDetailHeader';
import { SponsorAccountList } from '../Admin/Accounts/SponsorAccountList';
import System from 'src/helper/system';
import AdminConsoleHeader from '../Admin/AdminConsoleHeader';

const c = System.getParams();

const AccountDetail = () => {

  return (
    <>
      <div className='adminconsole-container'>
        <AdminConsoleHeader title={'ACCOUNT DETAILS'} />

        <AccountDetailHeader accountDetails={c} />

        <SponsorAccountList accountDetails={c} />
      </div>
    </>
  );
}

export default AccountDetail;